import { DistributionChannelsSubSection } from '@new/domains/properties/screens/propertyDistributionChannels/DistributionChannels.types'

const listingDescriptionFields = {
  'home.name': {
    title: 'Property Name',
  },
  title: {
    title: 'Headline',
  },
  summary: {
    title: 'Accommodations Summary',
  },
  description: {
    title: 'Description',
  },
  space: {
    title: 'Unique Benefits',
  },
  propertyType: {
    title: 'Property Type',
  },
}

export const vrboListingDataGroups = [
  {
    title: 'Listing Description',
    dataFields: listingDescriptionFields,
    sectionKey: DistributionChannelsSubSection.listingDescription,
  },
]
